'use client';

import React, { useEffect, useMemo, useState } from 'react';

interface CountdownProps {
  targetDate?: string | Date; // Optional targetDate
}

const FlashSaleCountdown: React.FC<CountdownProps> = ({ targetDate }) => {
  const targetTime = useMemo(() => {
    if (!targetDate) {
      return Date.now() + 2 * 24 * 60 * 60 * 1000;
    }

    return new Date(targetDate).getTime();
  }, [
    targetDate instanceof Date ? targetDate.getTime() : targetDate,
  ]);

  const calculateTimeLeft = (time: number): {
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
  } => {
    const difference = time - new Date().getTime();

    if (difference <= 0) {
      return { days: '00', hours: '00', minutes: '00', seconds: '00' };
    }

    return {
      days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(
        2,
        '0'
      ),
      hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(
        2,
        '0'
      ),
      minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(
        2,
        '0'
      ),
      seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, '0'),
    };
  };

  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(targetTime));

  useEffect(() => {
    setTimeLeft(calculateTimeLeft(targetTime));

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetTime));
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [targetTime]);

  return (
    <div className="countdown countdown--style2">
      <div className="countdown__block">
        <span className="countdown__number">{timeLeft.days}</span>
        <span className="countdown__label">Days</span>
      </div>
      <div className="countdown__block">
        <span className="countdown__number">{timeLeft.hours}</span>
        <span className="countdown__label">Hours</span>
      </div>
      <div className="countdown__block">
        <span className="countdown__number">{timeLeft.minutes}</span>
        <span className="countdown__label">Mins</span>
      </div>
      <div className="countdown__block">
        <span className="countdown__number">{timeLeft.seconds}</span>
        <span className="countdown__label">Secs</span>
      </div>
    </div>
  );
};

export default FlashSaleCountdown;
